import actionTypes from './actionTypes'
import config from '../../../config/config'

const {
  REQUEST_VALIDATION,
  RECEIVE_VALIDATION,
  REQUEST_RESET,
  RECEIVE_RESET,
  LINK_EXPIRED
} = actionTypes

export const linkExpired = bool => ({
  type: LINK_EXPIRED,
  expired: bool
})

const requestValidation = () => ({
  type: REQUEST_VALIDATION
})

export const receiveValidation = () => ({
  type: RECEIVE_VALIDATION
})

export function changePassword (authToken, email, password, token) {
  return function (dispatch) {
    dispatch({type: REQUEST_RESET})
    const payload = {
      email,
      password,
      password_confirmation: password,
      token
    }
    return fetch(`${config.URI}/api/v1/password_update`, {
      method: 'post',
      headers: {
        'Authenticity-Token': authToken,
        'Content-Type': 'application/json'
      },
      body: JSON.stringify(payload)
    })
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch({type: RECEIVE_RESET, resetSuccess: true, error: null})
          console.log(res)
        } else if (res.errors) {
          dispatch({
            type: RECEIVE_RESET,
            resetSuccess: false,
            error: res.errors
          })
          console.error(res.errors)
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}

export function checkActivation (email, token) {
  return function (dispatch) {
    dispatch(requestValidation())
    return fetch(
      `${config.URI}/api/v1/activate_check?email=${email}&token=${token}`
    ).then(res => {
      if (!res.ok) {
        throw Error(res.statusText)
      } else {
        return res.json()
      }
    })
  }
}

export function checkChangeEmail (email, token) {
  return function (dispatch) {
    dispatch(requestValidation())
    return fetch(
      `${config.URI}/api/v1/change_email_check?old_email=${email}&token=${token}`
    ).then(res => {
      if (!res.ok) {
        throw Error(res.statusText)
      } else {
        return res.json()
      }
    })
  }
}

export function checkPassword (email, token) {
  return function (dispatch) {
    dispatch(requestValidation())
    return fetch(
      `${config.URI}/api/v1/password_check?email=${email}&token=${token}`
    )
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(receiveValidation())
        } else if (res.errors) {
          dispatch(receiveValidation())
          dispatch(linkExpired(true))
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}

export function activateUser (email, token) {
  return function (dispatch) {
    return fetch(`${config.URI}/api/v1/activate?token=${token}&email=${email}`)
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(receiveValidation())
        } else if (res.errors) {
          dispatch(receiveValidation())
          dispatch(linkExpired(true))
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}

export function changeEmail (email, token) {
  return function (dispatch) {
    return fetch(`${config.URI}/api/v1/change_email_update?token=${token}&old_email=${email}`)
      .then(res => {
        if (!res.ok) {
          throw Error(res.statusText)
        } else {
          return res.json()
        }
      })
      .then(res => {
        if (res.status && res.status === 'success') {
          dispatch(receiveValidation())
        } else if (res.errors) {
          dispatch(receiveValidation())
          dispatch(linkExpired(true))
        }
      })
      .catch(e => {
        console.error(e)
        
      })
  }
}



// WEBPACK FOOTER //
// src/routes/ResetPassword/actions/index.js